module.exports = __webpack_public_path__ + "img/3s4.efb647ed.jpg";